export default __webpack_public_path__ + "static/assets/0b35c3a02f8b6bd517d9201acc59e1cd.gif";